const baseUrl = process.env.REACT_APP_API_BASE_URL;
export const apiKey = process.env.REACT_APP_API_KEY as string;

export const logInUrl = `${baseUrl}/auth/jwt/token`;
export const refreshTokenUrl = `${baseUrl}/auth/jwt/token/refresh`;
